import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { OverflowMenu, OverflowMenuItem } from '@entur/menu';
import { DownArrowIcon, UserIcon } from '@entur/icons';
import { useAuth } from 'hooks/context/useAuthContext';
import styles from './styles.module.scss';

interface UserMenuProps {
  isPending?: boolean;
  collapsed?: boolean;
}

const UserMenu = ({ isPending = false, collapsed = false }: UserMenuProps) => {
  const { getUser, logOut } = useAuth();
  const intl = useIntl();
  const navigate = useNavigate();

  const triggerButton = (
    <button type="button">
      <div className={collapsed ? styles.userIconSmall : styles.userIcon}>
        <UserIcon color="#ffffff" size={16} />
      </div>
      {!collapsed && (
        <>
          <div className={styles.name} title={isPending ? 'Verifiserer bruker...' : getUser()?.username}>
            {isPending ? 'Verifiserer bruker...' : getUser()?.name}
          </div>
          <DownArrowIcon className={styles.arrowIcon} color="#eee" />
        </>
      )}
    </button>
  );

  return (
    <OverflowMenu
      button={triggerButton}
      className={collapsed ? styles.collapsedMenu : styles.userMenu}
      aria-label={intl.formatMessage({ id: 'menu.userMenu' })}
      placement={collapsed ? 'right' : 'bottom-end'}
    >
      <OverflowMenuItem onSelect={() => navigate('/my-profile', { state: { restoreCrumbs: true } })}>
        {intl.formatMessage({ id: 'profilePage.myProfile' })}
      </OverflowMenuItem>
      <OverflowMenuItem onSelect={logOut}>{intl.formatMessage({ id: 'menu.logout' })}</OverflowMenuItem>
    </OverflowMenu>
  );
};

export default UserMenu;
